import React from "react"
import FluidImage from "../../../components/fluidImage"
import Video from "../../../components/video"

const ImageGrid = (props) => {

    const images = props.blok.images

    const isSingleImage = images.length == 1

    return (
        <section className={`width grid gap-3  lg:grid-cols-2 py-6 lg:py-10 lg:gap-x-[1.563rem] lg:gap-y-[2.625rem]`}>
            {
                images.map((image, index) => {
                    const hasVideo = image.video?.filename != undefined && image.video?.filename != ""

                    const containImage = image.contain_image || false

                    return (
                        <div key={`image-grid-${index}`} className={`${image.full_width ? `lg:col-span-2` : ``}`}>
                            {
                                hasVideo ? (
                                    <Video video={image.video} poster={image.image} className={`w-full h-full object-cover ${containImage ? `max-w-sm` : ``}`} />
                                ) :
                                (
                                    <FluidImage image={image.image} className={`w-full h-full object-cover ${containImage ? `lg:max-w-sm mx-auto` : ``}`}/>
                                )
                            }
                        </div>
                    )
                })
            }
        </section>
    )
}

export default ImageGrid